import styled from 'styled-components';

export const Table = styled.table`
width: 100%;
border-radius: 10px;
padding: 10px;
table-layout: auto;
`;

export const TableHead = styled.thead`
display: block;

@media screen and (max-width: 768px){
    border: none;
    clip: rect(0 0 0 0);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    width: 1px;
}
`;

export const TableBody = styled.tbody`
display: block;
`;

export const Row = styled.tr`
display: flex;
width: 100%;
border-bottom: 2px solid #F0F0F0;
background: ${({ dark }) => (dark ? '#F0F0F0' : '')};
border-radius: 10px;

@media screen and (max-width: 768px) {
    border-bottom: 3px solid #ddd;
    display: block;
    margin-bottom: .625em;
}
`;

export const NormalTableHeader = styled.th`
width: 100%;
display: flex;
flex: 1;
padding: 10px;
letter-spacing: 0.5px;
`;

export const SmallTableHeader = styled.th`
width: 25%;
display: flex;
flex: 0.25;
padding: 10px;
justify-content: center;
align-items: center;
letter-spacing: 0.5px;
`;

export const NormalTableCell = styled.td`
width: 100%;
display: flex;
flex: 1;
padding: 10px;

@media screen and (max-width: 768px) {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
    text-align: right;

    &:before {
    content: attr(data-label);
    float: left;
    font-weight: bold;
    text-transform: uppercase;
}}
`;

export const SmallTableCell = styled.td`
width: 25%;
display: flex;
flex: 0.25;
padding: 10px;
justify-content: center;
align-items: center;

@media screen and (max-width: 768px) {
    border-bottom: 1px solid #ddd;
    display: block;
    font-size: .8em;
}
`;

export const RemoveIcon = styled.button`
display: flex;
align-items: center;
font-size: 20px;
width: fit-content;
height: fit-content;
background: none;
border: none;

&:hover {
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    transform: scale(1.05);
    color: red;
}
`;
